import { render, staticRenderFns } from "./my-info-updated.vue?vue&type=template&id=45e33106&"
import script from "./my-info-updated.vue?vue&type=script&lang=ts&"
export * from "./my-info-updated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports